import Service from '@/js/service.js'
import OSS from 'aliyun-oss-sdk'
import md5 from 'js-md5';

var systemService = {};


/**
 *官网展示数据
 * @param vm
 * @returns {*}
 */
systemService.displayList = function (vm, obj) {
  let paramData = {
    type: obj.type,
    language: obj.language,
    queryStr: vm.queryStr,
    queryType: vm.queryType,
  }
  // debugger
  return Service.get(vm, 'officialWebsite/displayList', paramData);
};
/**
 * 官网查询案例数据
 */
systemService.commitAdvice = function (vm, obj) {
  let data = {
    name: obj.name,
    mobile: obj.mobile,
    position: obj.position,
    companyName: obj.companyName,
  }
  return Service.post(vm, 'officialWebsite/commitAdvice', data);
};
/**
/**
 * 官网查询案例数据
 */
systemService.getCaseList = function (vm, language) {
  let data = {
    language: language
  }
  return Service.post(vm, 'officialWebsite/getCaseList', data);
};
/**
 * 官网查询行业报告数据
 */
systemService.getReportList = function (vm, language) {
  let data = {
    language: language
  }
  return Service.post(vm, 'officialWebsite/getReportList', data);
};

/**
 * 点击量+1
 */
systemService.editHitsNum = function (vm, officialWebsiteId) {
  let data = {
    officialWebsiteId: officialWebsiteId
  }
  return Service.get(vm, 'officialWebsite/editHitsNum', data);
};

/**
 *
 * 获取师资介绍分类
 * 
 */

systemService.getTeacherTypeList = function (vm, language) {
  let data = {
    language: language
  }
  return Service.get(vm, 'officialWebsite/getTeacherTypeList', data);
};


// export const getTeacherTypeList = (officialWebsiteId) => {
//   return request({
//     url: "/officialWebsite/getTeacherTypeList",
//     method: 'get',
//     params: {
//       officialWebsiteId: officialWebsiteId
//     }
//   })
// }


// /**
//  * 取得私密写公共读的OSS上传对象
//  * @param vm
//  * @returns {*}
//  */
// systemService.getOSSClientPrivateWrite = function (vm) {
//   return Service.get(vm, "document/privateWriteToken").then(function (data) {
//     var client = new OSS(data);
//     return client;
//   });
// };

// /**
//  * 发送验证码
//  * @param vm
//  * @param mobile 用户手机号码
//  * @param sign 加密算法
//  * @param timeStamp 时间戳
//  */
// systemService.sendValidate = function (vm, mobile, sign, timeStamp) {
//   var data = {
//     mobile: mobile,
//     sign: sign,
//     timestamp: timeStamp
//   };
//   return Service.post(vm, 'phone/contact/verifyCode', data);
// };
// /**
//  * md5加密
//  * @param mobile
//  * @param timeStamp
//  */
// systemService.encryption = function (mobile, timeStamp) {
//   var appid = 'sysBosumVerification';
//   var appSecret = 'f94fdab1a50f4a45a6332e08311f96ff';

//   var normalUrl = '/phone/contact/verifyCode';
//   //参数排序
//   var params = {
//     "appid": appid,
//     "mobile": mobile,
//     "method": normalUrl,
//     "timestamp": timeStamp
//   };
//   return systemService.getSign(params, appSecret);
// };

// systemService.getSign = function (params, appSecret) {
//   var paramList = [];
//   for (var pos in params) {
//     paramList.push(pos);
//   }
//   var paramArr = paramList.sort();
//   for (var i = 0; i < paramArr.length; i++) {
//     var paramValue = params[paramArr[i]];
//     paramArr[i] = paramArr[i] + paramValue;
//   }
//   var paramStr = paramArr.join('');
//   var resultStr = appSecret + paramStr + appSecret;
//   //MD5 加密
//   resultStr = md5(resultStr);
//   console.log(resultStr);
//   return resultStr;
// };
// /**
//  * 登录
//  * @param vm
//  * @param phone 用户手机号码
//  * @param verificationCode 验证码
//  */
// systemService.login = function (vm, phone, verificationCode) {
//   var data = {
//     phone: phone,
//     verificationCode: verificationCode
//   };
//   return Service.post(vm, 'api/contact/erpContactLogin', data);
// };

// /**
//  * 获取课程列表
//  * @param vm
//  * @returns {*}
//  */
// systemService.getGradeCoursePlanList = function (vm) {
//   return Service.get(vm, 'api/grade/getGradeCoursePlanList');
// };

// /**
//  * 作业列表
//  * @param vm
//  * @param coursePlanId
//  * @returns {*}
//  */
// systemService.getHomeworkList = function (vm, coursePlanId) {
//   var data = {
//     coursePlanId: coursePlanId
//   };
//   return Service.get(vm, 'api/grade/getHomeworkList', data);
// };

// /**
//  * 上传作业信息
//  * @param vm
//  * @param entityId
//  * @param mark
//  * @param contactId
//  * @param urls
//  * @returns {*}
//  */
// systemService.createHomework = function (vm, entityId, mark, contactId, urls) {
//   var data = {
//     entityId: entityId,
//     mark: mark,
//     contactId: contactId,
//     urls: urls
//   };
//   return Service.post(vm, 'api/grade/createHomework', data);
// };
// /**
//  * 证书列表查询
//  * @param vm
//  * @param queryCondition
//  * @returns {*}
//  */
// systemService.getCertificateList = function (vm, queryCondition) {
//   var data = {
//     'queryCondition': queryCondition
//   };
//   return Service.erpGet(vm, 'certificate/list', data);
// };

// /**
//  * 保存客户
//  * @param vm
//  * @param visitorName
//  * @param visitorMobile
//  * @returns {*}
//  */
// systemService.applySave = function (vm, visitorName, visitorMobile) {
//   var data = {
//     visitorName: visitorName,
//     visitorMobile: visitorMobile
//   };
//   return Service.erpPost(vm, 'api/siteVisitor/save', data);
// };
// //首页导师json
// systemService.getTeacherList = function () {
//   return [
//     {
//       id: '11',
//       name: '刘炳成',
//       order: '1',
//       label: 'liubincheng',
//       briefList: ['博商管理科学研究院联合创始人/院长 ', '清华大学深圳研究生院博商民企联合研究中心领导力专家', '“突破性领导力”创始人'],
//       desc: '原南京陆军指挥学校优秀军事教官，曾任教中国人民解放军南京陆军指挥学院，留任期间参与编写我国第一部关于战术学这门学科体系教材。后来弃戎从商，将军事教练技术移植到企业经营管理，成绩斐然。',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/liubincheng.png',
//     },
//     {
//       id: '19',
//       name: '曾任伟',
//       order: '2',
//       label: 'zengrenwei',
//       briefList: ['博商管理科学研究院联合创始人/院长', '香港理工大学管理学博士', '“博三角”概念创始人'],
//       desc: '知名企业教练与实战专家，20年致力于成长型企业系统管理解决方案的研究实践，曾辅导安奈儿、奥拓、海洋王等多家企业实现规模性增长。',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/zengrenwei.png',
//     },
//     {
//       id: '10',
//       name: '章义伍',
//       order: '3',
//       label: 'zhangyiwu',
//       briefList: ['博商特聘导师 ', '麦当劳(中国)创业元老', '连续10年被评为”中国十大杰出培训师“', '曾获“黄炎培教育专家奖”和“中国教育育才杰出贡献奖'],
//       desc: '实力派管理培训专家，擅长流程变革、领导力、团队管理、组织执行力等领域。曾服务中化集团、中石油、五矿集团、诺基亚、蒙牛集团、美的集团等数百家企业，累计培训企业家和企业高管超过200000人。',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/zhangyiwu.png',
//     },
//     {
//       id: '12',
//       name: '张琦',
//       order: '4',
//       label: 'zhangqi',
//       briefList: ['博商新商业增长落地班特聘导师 ', '新商业架构师 ', '企业盈利增长模式专家', '商业类目现象级IP', '多家知名企业资深商业顾问'],
//       desc: '',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/zhangqi.png',
//     },
//     {
//       id: '25',
//       name: '郑翔洲',
//       order: '5',
//       label: 'zhengxiangzhou',
//       briefList: ['博商企业利润增长特训营特聘导师', '优势资本合伙人、商业模式设计专家', '《商界评论》首席经济学家', 'CLPA2019年度最佳风险投资家'],
//       simpleBriefList: ['博商企业利润增长特训营特聘导师', '优势资本合伙人、商业模式设计专家', '《商界评论》首席经济学家'],
//       desc: '1919酒类直供，南京越博动力，澜起科技，微医集团，微盟，豆盟科技，深华新（000010）并购，棒杰股份（002634）并购，罗牛山（000735）并购。',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/zhengxiangzhou.png',
//     },
//     {
//       id: '24',
//       name: '程广见',
//       order: '6',
//       label: 'chengguangjian',
//       briefList: ['博商总裁行动项目特聘销售讲师', '销售全流程与信用回款实践研究专家', '知名销售专家', '《得到锦囊》专家委员'],
//       desc: '曾经就职于德国拜耳公司（世界500强）、 America Asian Sun Seeds Co.（中美合资）、光彩国际（民营）；历任财务经理、信用经理、销售经理、销售总监、董事总经理；具有十五年丰富的一线市场销售、回款及管理经验。',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/chengguangjian.png',
//     },
//     {
//       id: '23',
//       name: '吕定杰',
//       order: '7',
//       label: 'lvdingjie',
//       briefList: ['博商企业利润增长特训营财税专家', '企业财务管理专家、投资与资产管理专家', '北京大财有道咨询公司联合创始人', '浙江长策资产管理公司联合创始人'],
//       simpleBriefList: ['博商企业利润增长特训营财税专家', '企业财务管理专家、投资与资产管理专家', '北京大财有道咨询公司联合创始人'],
//       desc: '曾就职500强企业，后加入国内大型事务所咨询部门，从事上市公司并购重组、尽职调查与财务管理咨询工作，擅长为企业提供企业财务系统建设、节税规划、并购上市、全球资产管理等领域的服务。',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/lvdingjie.png',
//     },
//     {
//       id: '3',
//       order: '8',
//       name: '曹际鹏',
//       label: 'caojipeng',
//       briefList: ['博商管理科学研究院首席战略导师', '曾任万科百亿到千亿项目执行组长', '曾任国家发改委国际合作中心特聘专家'],
//       desc: '专注咨询实战20年，致力于企业顶层设计、战略规划、运营管理、商业模式的项目咨询，曾任波司登、奥飞动漫、华商报业集团战略项目组长，为TCL、立白、腾讯、中国惠普、核服集团、盼盼集团等企业提供咨询服务。',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/caojipeng.png',
//     },
//     {
//       id: '2',
//       order: '9',
//       name: '王岑',
//       label: 'wangcen',
//       briefList: ['博商企业利润增长特训营特聘导师', '消费投资领域领军人物', '专注消费品牌投资20年'],
//       desc: '现任B资本董事长、前红杉资本中国合伙人、前天图资本合伙人，曾成功投资五爷拌面、Colorkey彩妆、艾德维、 溜溜梅, 甘源食品、周黑鸭、云米家电、泰迪居家、美年健康、曼卡龙珠宝、等近百个中国知名消费品牌。',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/wangcen.png',
//     },
//     {
//       id: '4',
//       name: '叶建平',
//       order: '10',
//       label: 'yejianpin',
//       briefList: ['博商总裁行动项目特聘财税讲师', '实战派财税筹划专家', '执业注册会计师、执业注册税务师'],
//       desc: '13年国家税务局稽查工作经验、15年企业财税管理经验，是国内少有的兼有税务机关稽查经验与企业财税实战管理经验的双栖财税专家，是“企业税收管理七大工具”、”稽查现场接待规范“、”八位一体税收管理体系”等创始人。',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/yejianpin.png',
//     },
//     {
//       id: '7',
//       name: '张建财',
//       order: '11',
//       label: 'zhangjiancai',
//       briefList: ['博商独家师资事业部总监', '原华润集团万家学院领导力发展资深专家', '原富安娜集团富安娜商学院执行院长', '原金蝶软件金蝶大学企业客户部培训负责人'],
//       simpleBriefList: ['博商独家师资事业部总监', '原华润集团万家学院领导力发展资深专家', '原金蝶软件金蝶大学企业客户部培训负责人'],
//       desc: '专注于人才发展、干部管理及领导力开发十九年，擅长领导者的培养与发展，以及变革时期的组织和人才发展，曾为中国移动、建设银行等央企提供转型期的组织及人才发展解决方案和落地咨询服务。',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/zhangjiancai.png',
//     },
//     {
//       id: '6',
//       name: '孙义永',
//       order: '12',
//       label: 'sunyiyong',
//       briefList: ['博商商业模式讲师', '实战派商业模式设计专家、华为大学优秀讲师', '原华为全球CDMA解决方案销售部部长、原深圳市永华浩科技有限公司创始人'],
//       desc: '任职华为全球CDMA销售副总裁期间，带领全球200多人的跨区域团队取得了年销售收入150多亿元的骄人业绩，期间华为CDMA产品雄踞全球市场份额第一。曾主导中国电信全国3G项目投标，市场份额从3%提升到40%，市场份额第一。',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/sunyiyong.png',
//     },
//     {
//       id: '9',
//       name: '何建',
//       order: '13',
//       label: 'hejian',
//       briefList: ['博商管理CFO ', '金蝶软件集团（上市）集团财务咨询总监 、某外企金融公司（上市）CFO', '港中旅集团（上市）财务副总'],
//       desc: '实战经验：帮助企业从几十人规模发展到几百人，并成功上市；融资200亿，谈判40多家世界级顶级投资机构；咨询经验：亲自操刀财务咨询项目20余个，项目横跨十几个行业；结合自身多年财务管理及咨询经验，亲自开发一套适合民企的财务管理体系及实用方法工具。',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/hejian.png',
//     },
//     {
//       id: '13',
//       name: '曾任果',
//       order: '14',
//       label: 'zengrenguo',
//       briefList: ['博商管理科学研究院副院长', '博商汇联合创始人、名誉会长', 'EDP 教育专家'],
//       desc: '',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/zengrenguo.png',
//     },
//     {
//       id: '14',
//       name: '李淼',
//       order: '15',
//       label: 'limiao',
//       briefList: ['曹际鹏战略与运营研究院运营负责人', '原华为大学重大客户培训项目负责人', '原华润万家领导力学院个人领导力发展负责人', '原碧桂园集团营销学院领导力副总监'],
//       simpleBriefList: ['曹际鹏战略与运营研究院运营负责人', '原华为大学重大客户培训项目负责人', '原华润万家领导力学院个人领导力发展负责人'],
//       desc: '17年CEO及高管培养经验，专注团队领导力打造，企业大学的从0-1的搭建，具有丰富的中小民企服务经验。',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/limiao.png',
//     },
//     {
//       id: '1',
//       order: '16',
//       name: '徐白琳',
//       label: 'xubailin',
//       briefList: ['博商管理财务管理讲师', '博商管理财务副总裁', '曾任新百伦中国区财务总监', '曾任胡桃里财务总经理', '曾任百威英博、联合利华等知名外企的财务经理'],
//       desc: '20余年财务管理经验，曾为新百伦中国搭建财务体系，帮助公司从亏损到实现30亿净利润；为合纵文化完成港股上市筹备，完成财务体系重组与合规化整改。',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/xubailin.png',
//       smImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_small/xubailin.png',
//     },
//     {
//       id: '21',
//       name: '方少兵',
//       order: '17',
//       label: 'fangshaobin',
//       briefList: ['博商咨询项目总监', '运营效率升级落地咨询师', '曾为四大银行、机场、美的、波司登等提供绩效管理与精益流程咨询服务', '指导多家民企实施降本增效，实现快速增长'],
//       simpleBriefList: ['博商咨询项目总监', '运营效率升级落地咨询师', '曾为四大银行、机场、美的、波司登等提供绩效管理与精益流程咨询服务'],
//       desc: '咨询经历:丰富的500强与民企企业咨询经验，曾为四大银行、机场、美的、波司登等提供绩效管理与精益流程咨询服务；服务博商中小民企，帮助企业实现降本增效。实战经验：服装、科技领域创业者，企业最高估值曾达13亿美金。',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/fangshaobin.png',
//     },
//     {
//       id: '20',
//       name: '许林芳',
//       order: '18',
//       label: 'xulinfang',
//       briefList: ['博商管理特聘导师', '前阿里巴巴资深经理', '前农夫山泉人力资源总经理（CHO）'],
//       desc: '',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/xulinfang.png',
//     },
//     {
//       id: '22',
//       name: '傅志军',
//       order: '19',
//       label: 'fuzhijun',
//       briefList: ['营销管理与咨询专家', '博商特聘营销管理导师', '龙行营销咨询创始人', 'CMC国际注册管理咨询师', '湖南大学EDP培训中心特聘营销导师', '西安交大EMBA中心客座教授 ', '广东省企业管理咨询协会副会长', '中国营销咨询行业十大领军人物（2019年（第三届）博鳌企业论坛颁发）', '《品牌新势力》企业家访谈栏目出品人 '],
//       simpleBriefList: ['营销管理与咨询专家', '博商特聘营销管理导师', '龙行营销咨询创始人', '湖南大学EDP培训中心特聘营销导师 '],
//       desc: '',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/fuzhijun.png',
//     },
//     {
//       id: '26',
//       name: '李景',
//       order: '20',
//       label: 'lijing',
//       briefList: ['博商管理CHO', '实战派人力资源专家', '原世联行人力资源总经理'],
//       desc: '博商首席人力资源教练，辅导上百家同学企业解决组织发展，绩效薪酬改革、人才甄选等人才管理难题。',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/lijing.png',
//     },
//     {
//       id: '17',
//       name: '董仁杰',
//       order: '21',
//       label: 'dongrenjie',
//       briefList: ['博商销售管理讲师', '原中兴通讯海外子公司总经理', '丰富的销售管理经验和销售铁军打造经验', '超十亿项目的操盘手'],
//       desc: '中兴通讯任职期间，成功操盘超2亿美金的政府单个项目；成功操盘中兴年度最大企业网海外单个项目；累计清收欠款超20亿人民币；拥有丰富的销售管理经验和从0到1的销售铁军打造经验。',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/dongrenjie.png',
//     },
//     {
//       id: '15',
//       name: '奉超',
//       order: '22',
//       label: 'fengchao',
//       briefList: ['战略与运营实战专家', '原美的集团某事业部总监', '原新希望六和股份公司经营管理总经理助理', '真功夫战略总监，数字化运营总经理'],
//       desc: '专注企业战略制定与落地，曾参与并主导美的多个投资并购项目，主导推动重要战略落地与执行。博商资深运营教练，通过深度辅导、主题研讨、私董会等形式，帮助学员企业提升战略落地、高效协同等运营难题。',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/fengchao.png',
//     },
//     {
//       id: '16',
//       name: '吴梓境',
//       order: '23',
//       label: 'wuzijin',
//       briefList: ['北京大学博士后、北京师范大学博士，上海交通大学EMBA高级讲师。', '曾任职于方正证券、国金基金、金雅资本', '目前担任鑫甬生物独立董事、中南高科非执行董事。'],
//       simpleBriefList: ['北京大学博士后、北京师范大学博士，上海交通大学EMBA高级讲师。', '曾任职于方正证券、国金基金、金雅资本'],
//       desc: '',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/wuzijin.png',
//     },
//     {
//       id: '8',
//       name: '李力刚',
//       order: '24',
//       label: 'liligang',
//       briefList: ['商业谈判训练专家 ', '博商特聘导师', '海盟企管创始人', '曾任台湾裕隆集团大陆办副总经理', '曾任联想华东区增值渠道总监'],
//       simpleBriefList: ['商业谈判训练专家 ', '博商特聘导师', '海盟企管创始人', '曾任台湾裕隆集团大陆办副总经理'],
//       desc: '',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/liligang.png',
//     },
//     {
//       id: '5',
//       order: '25',
//       name: '叶旭东',
//       label: 'yexudong',
//       briefList: ['博商管理特聘导师', '企业新媒体营销实战专家、抖音营销顾问', '前字节跳动市场运营负责人', '字节跳动信息流广告核心讲师'],
//       desc: '',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/yexudong.png',
//     },
//     {
//       id: '18',
//       name: '申晨',
//       order: '26',
//       label: 'shenchen',
//       briefList: ['博商新商业CEO创新班新营销导师', '熊猫传媒集团董事长', '新浪微博创始团队成员', '新媒体营销方法论“熊猫罗盘”的创造者'],
//       desc: '曾参与策划指导众多中国新媒体营销活动，如现象级案例“不懂体”病毒营销事件、三星钢铁侠手机、得力保险箱神文案、圣元“一口奶十三问”小吉智能迷你滚筒洗衣机PRO社会化营销等。',
//       bgImg: 'https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/home/teacher_bg/shenchen.png',
//     }
//   ];
// };

export default systemService;



// WEBPACK FOOTER //
// ./src/api/system.js